<div
  class="prs-password-requirements"
  data-testing-id="prs-password-requirements"
  role="group"
  [attr.aria-label]="'account.password.requirement.list_label' | translate"
>
  @for (rule of requirements(); track rule.id) {
  <div
    class="prs-password-requirements__item"
    [class.prs-password-requirements__item--met]="rule.met"
    [attr.data-testing-id]="'prs-password-req-' + rule.id"
    [attr.aria-checked]="rule.met"
    role="checkbox"
  >
    <span class="prs-password-requirements__icon" aria-hidden="true">
      @if (rule.met) {
      <i class="bi bi-check-circle-fill"></i>
      } @else {
      <i class="bi bi-dash-lg"></i>
      }
    </span>
    <span class="prs-password-requirements__label">{{ rule.labelKey | translate }}</span>
  </div>
  }
</div>
